<template>
  <div>
    <slot :years="years"></slot>
  </div>
</template>

<script>
import { eachYearOfInterval } from 'date-fns'
import { getYear } from 'date-fns/esm'
export default {
  name: 'GeneratorYears',
  props: {
    startDate: {type: Date, required: true},
    endDate: {type: Date, required: true},
  },
  computed: {
    years () {
      return eachYearOfInterval({
        start: this.startDate, 
        end: this.endDate
      }).map(date => getYear(date))
    },
  },
}
</script>